export default function getUserOperatingSystem(navigator: Navigator) {
  const ua = navigator.userAgent;

  if (/android/i.test(ua)) {
      return 'ANDROID';
  }

  if (/iPad|iPhone|iPod/.test(ua)) {
      return 'IPHONE';
  }

  return 'WEB';
};